<div class="container-fluid container-list">
    <app-variedad-filter [dialogMode]="dialogMode" [grupos]="grupos" [formas]="formas" [lastFilter]="payload"
                     (search)="onSearch($event)" (cleanForm)="onReset()" (groupSelected)="onGroupSelected($event)"></app-variedad-filter>

    <app-variedad-list *ngIf="searching" [selectionMode]="dialogSelectionMode" [result]="result" [lastFilter]="payload" 
        (search)="onSearchLazy($event)" (selectVariedad)="onSelectVariedad($event)" (undoSelectVariedad)="onUndoSelect($event)"></app-variedad-list>
</div>
